import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { UserAvatar, UserBasic } from "src/util/types/dataModels/user"

//region Types

export type UserCollection = RxCollection<UserBasic>
export type UserDocument = RxDocument<UserBasic>

export type UserAvatarCollection = RxCollection<UserAvatar>
export type UserAvatarDocument = RxDocument<UserAvatar>

//endregion

/**
 * Schema for user roles collections
 */
export const userSchema: RxJsonSchema<UserBasic> = {
  title: "User schema",
  description: "Collection of all users",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true }, // UUID

    email: { type: "string", minLength: 1, maxLength: 254 },

    first_name: { type: "string", maxLength: 150 },

    last_name: { type: "string", maxLength: 150 },

    is_active: { type: "boolean" },

    is_superuser: { type: "boolean" },

    roles: { type: "array", items: { type: "string", maxLength: 36, uniqueItems: true } },
  },
  required: ["id", "email", "roles"],
}

export const userAvatarSchema: RxJsonSchema<UserAvatar> = {
  title: "User schema",
  description: "Collection of all users",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { ref: "attachments", type: "string", maxLength: 36, uniqueItems: true },
    path: { type: "string" },
    type: { type: "string" },
  },
  required: ["id", "path", "type"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const userCollectionCreator: RxCollectionCreator = {
  schema: userSchema,
}

export const userAvatarCollectionCreator: RxCollectionCreator = {
  schema: userAvatarSchema,
}
